import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const taskDefinition = {
  state: { editedTask: undefined, tasks: [] },
  getters: { editedTask: (state) => state.editedTask, tasks: (state) => state.tasks },
  mutations: {
    tasks: (state, value) => (state.tasks = value ?? []),
    editedTask: (state, value) => (state.editedTask = value),

    addTaskItem: (state, { task }) => {
      if (!task._id) {
        task._id = "id" + new Date().getTime(); //id atama
      }

      state.tasks = [...state.tasks, { ...task }];
    },
    updateTaskItem: (state, { task }) => {
      state.tasks = state.tasks.map((t) => {
        if (t._id == task._id) {
          t = task;
        }

        t.blockedByTasks = t.blockedByTasks?.map((x) => {
          if (x._id == task._id) {
            return task;
          }
          return x;
        });

        return t;
      });
    },

    removeTaskItem: (state, { task }) => {
      state.tasks = [...state.tasks.filter((t) => t._id != task._id)];
    },
    reset: (state, value) => {
      state.editedTask = undefined;
      state.tasks = [];
    },
  },
  actions: {},
};

export const organizationPolicy = createCrudVuexModule({
  namespaced: true,
  path: "/policy",
  persistent: ["selectedWorkedFilter", "selectedCategoryFilter", "selectedPolicyGroupFilter"],
  state: {
    ...taskDefinition.state,
    form: undefined,
    policy: undefined,
    policyId: undefined,
    isCreating: false,
    isEditing: false,
    isDownloading: false,
    selectedWorkedFilter: "WAITING_FOR_ASSESSMENT",
    selectedCategoryFilter: undefined,
    selectedPolicyGroupFilter: undefined,
  },
  getters: {
    ...taskDefinition.getters,
    isDownloading: (state) => state.isDownloading,
    form: (state) => state.form,
    policy: (state) => state.policy,
    policyId: (state) => state.policyId,
    isCreating: (state) => state.isCreating,
    isEditing: (state) => state.isEditing,
    isReading: (state) => !state.isEditing && !state.isCreating,
    selectedWorkedFilter: (state) => state.selectedWorkedFilter,
    selectedCategoryFilter: (state) => state.selectedCategoryFilter,
    selectedPolicyGroupFilter: (state) => state.selectedPolicyGroupFilter,
  },
  mutations: {
    ...taskDefinition.mutations,
    isDownloading: (state, value) => (state.isDownloading = value),
    form: (state, value) => (state.form = value),
    policy: (state, value) => (state.policy = value),
    policyId: (state, value) => (state.policyId = value),
    selectedWorkedFilter: (state, value) => (state.selectedWorkedFilter = value),
    selectedCategoryFilter: (state, value) => (state.selectedCategoryFilter = value),
    selectedPolicyGroupFilter: (state, value) => (state.selectedPolicyGroupFilter = value),
    isCreating: (state, value) => {
      state.isCreating = value;

      state.policyId = undefined;
      state.policy = undefined;
      state.isEditing = false;
      state.form = {};
    },
    isEditing: (state, value) => {
      state.isEditing = value;
      if (value) {
        state.isCreating = false;
      }
    },
    reset: (state, value) => {
      state.policyId = undefined;
      state.policy = undefined;
      state.isEditing = false;
      state.isCreating = false;
      state.form = {};
    },
    resetFilters: (state, value) => {
      state.selectedWorkedFilter = "WAITING_FOR_ASSESSMENT";
      state.selectedCategoryFilter = undefined;
      state.selectedPolicyGroupFilter = undefined;
    },
    removePolicyFromPagination: (state, id) => {
      state.pagination.docs = state.pagination.docs.filter((i) => i._id != id);
    },
  },

  actions: {
    ...taskDefinition.actions,
    async download({ commit }, payload) {
      commit("isDownloading", true);
      try {
        const response = await rest.post("/policy/download", payload);
        return response;
      } finally {
        commit("isDownloading", false);
      }
    },
    async complianceStatusBulkUpdate({ commit }, payload) {
      commit("isUpdating", true);
      try {
        return rest.put(`/policy-compliance-status/bulk`, { item: payload });
      } finally {
        commit("isUpdating", false);
      }
    },
    async changePolicyStatus({ commit }, id) {
      commit("isUpdating", true);
      try {
        return rest.put(`/policy/status`, { id: id });
      } finally {
        commit("isUpdating", false);
      }
    },
    async fetchDetail({ getters, commit, dispatch }, id) {
      try {
        commit("isLoading", true);
        const response = await rest.get(`/policy/${id}`);
        commit("policy", response.data);

        return response.data;
      } finally {
        commit("isLoading", false);
      }
    },
    async delete({ commit, dispatch }, payload) {
      try {
        //silmiyoruz statusun notapplicable yapıyoruz
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", { editedEntity: {}, form: payload });
        const response = await rest.post(`/policy/delete`, payload);
        return response.data;
      } finally {
        commit("isUpdating", false);
      }
    },

    async revertDeleted({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", { editedEntity: {}, form: payload });
        const response = await rest.post(`/policy/revert-deleted`, payload);

        return response.data;
      } finally {
        commit("isUpdating", false);
      }
    },
    async fetchDetailAndUpdateOnPaginate({ getters, commit, dispatch }, id) {
      try {
        const response = await rest.get(`/policy/${id}`);

        commit("pagination", {
          ...getters.pagination,

          docs: getters.pagination.docs.map((i) => {
            if (i._id == id) {
              return response.data;
            }
            return i;
          }),
        });

        return response.data;
      } finally {
        commit("isLoading", false);
      }
    },

    async updateComplianceStatus({ commit }, payload) {
      commit("isUpdating", true);
      try {
        return rest.put(`/policy-compliance/status`, payload);
      } finally {
        commit("isUpdating", false);
      }
    },
    async updateComplianceDescription({ commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        payload = await dispatch("preparePayload", { editedEntity: {}, form: payload });

        return rest.put(`/policy-compliance/description`, payload);
      } finally {
        commit("isUpdating", false);
      }
    },

    async updatePeriod({ commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        return rest.put(`/policy/period`, payload);
      } finally {
        commit("isUpdating", false);
      }
    },
    async updateTargetComplianceStatus({ commit }, payload) {
      commit("isUpdating", true);
      try {
        return rest.put(`/policy-compliance/target-status`, payload);
      } finally {
        commit("isUpdating", false);
      }
    },

    //relations
    async removePolicyRiskRelation({ commit }, payload) {
      try {
        return rest.post(`/policy-relation/risk`, payload);
      } finally {
      }
    },
    async addPolicyRiskRelation({ commit }, payload) {
      try {
        return rest.post(`/policy-relation/risk/add`, payload);
      } finally {
      }
    },
  },
});
